import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs/Rx';
import { Router } from '@angular/router';
import { BehaviorSubject } from 'rxjs/BehaviorSubject';
import { JwtHelper, tokenNotExpired } from 'angular2-jwt';
import { environment } from '../../../environments/environment';

@Injectable()
export class AuthService {

  private apiUrl:string = environment.apiUrl.tokens;
  private atKey:string = 'at';
  private rtKey:string = 'rt';
  private loginSource = new BehaviorSubject<boolean>(false);
  currentLogin = this.loginSource.asObservable();
  loggedIn: boolean = false;
  data: any = null;
  jwtHelper: JwtHelper = new JwtHelper();
  redirectUrl: string;

  constructor(
    private http: HttpClient,
    private _router: Router
  ) {
  }

  /**
   *  Get the token out of local storage
   */
  public getAuthToken() {
    return localStorage.getItem(this.atKey);
  }


  /*
      The call that goes in here will use the existing refresh token to call
      a method on the oAuth server (usually called refreshToken) to get a new
      authorization token for the API calls.
  */
  refreshToken() {
    let rt:string = localStorage.getItem(this.rtKey);
    let url = `${this.apiUrl}/${rt}`;

    // Make a post to the server to validate token. If valid, a new access
    // access token and refresh token will be issued by the server and returned
    // the the response.


      return this.http.get(url);
   }


  /**
   *  Check permission level for a user
   */
  hasPermissions(permissionLevel) {
    let permissions = localStorage.getItem('role') || '';
    if(permissions !== null &&
       permissions !== undefined &&
       Object.keys(permissions).length !== 0 && permissions === permissionLevel ) {
      return true;
    } else {
      return false;
    }
  }


  /**
   * login
   *
   */
  login(username: string, password: string): any {
    let user = JSON.stringify({
      "username": username,
      "password": password
    });

    // Make a post to the server to get the token back.
    return this.http.post(this.apiUrl, user);
  }


  /**
   *  Handle an error
   */
  handleError() {
    this.loginSource.next(false);
  }


  /**
   *  Do all the login stuff
   */
  handleJWT(data) {

    let at = data['at']
    let rt = data['rt']
    let role = data['role']
    let ret = data['ret']

    // Parse access token; save values to localStorage.
    localStorage.setItem('un', this.jwtHelper.decodeToken(at).username);
    localStorage.setItem('fn', this.jwtHelper.decodeToken(at).full_name);

    // Store the user in local storage.
    localStorage.setItem('at', at);
    localStorage.setItem('rt', rt);
    localStorage.setItem('role', role);
    localStorage.setItem('ret', ret);

    // Redirect to home screen.
    this.loginSource.next(true);
    this._router.navigate(['/']);
  }


  /**
   * logout
   *
   */
  logout() {

    // Remove the refresh token record from the db
    let rt = localStorage.getItem('rt');
    let rtUrl = `${this.apiUrl}/${rt}`;
    this.http.delete(rtUrl).take(1).subscribe();

    localStorage.clear();

    this.loginSource.next(false);
    this._router.navigate(['/login']);
  }


  /**
   *  More straightforward function for checking
   *  if JWT is expired
   */
  isTokenExpired(token) {
    return !tokenNotExpired();
  }


  /**
   *  Check if a user is logged in
   *    - If the user tries to go to a page that requires login
   *      check their login status and refresh tokens, if need be
   *
   */
  isLoggedIn(): Observable<boolean> {
    // Does access token exist?
    if(tokenNotExpired(this.atKey)) {
      this.loggedIn = true;
      return Observable.of(true)
    } else {

      // If access token does not exist, check refresh token.
      let rt:string = localStorage.getItem(this.rtKey);

      // If no refresh token, return false.
      if (rt) {
        return this.refreshToken().switchMap(
          data => {
            let rat = data['at'];
            let rrt = data['rt'];
            let rr = data['role'];
            let rret = data['ret'];

            // Parse access token; save values to localStorage.
            localStorage.setItem('fn', this.jwtHelper.decodeToken(rat).full_name);
            localStorage.setItem('un', this.jwtHelper.decodeToken(rat).username);

            // Store the user in local storage.
            localStorage.setItem('at', rat);
            localStorage.setItem('rt', rrt);
            localStorage.setItem('role', rr);
            localStorage.setItem('ret', rret);

            this.loggedIn = true;

            return Observable.of(true)
          }
        )
      } else {
        this.loggedIn = false;
        return Observable.of(false)
      }
    }
  }

}



// WEBPACK FOOTER //
// ./src/app/shared/services/auth.service.ts